import React, { Component } from 'react';
import { getListPaciente, getListPacienteAlgolia } from '../../Libs/paciente'
import { getLoggedInUser } from "../../helpers/authUtils";
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { onlyNumbers } from '../../helpers/utils';

var timer;

export default class DropDownPacientesAlgolia extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pacientes: [],
      pacientesShow: [],
      pacienteSelecionado: this.props.pacienteSelecionado,
      lastFind: null
    };
  }


  // async componentDidUpdate() {
  //   if (this.props.updateDropDown && this.props.updateDropDown === true) {
  //     // await this.atualizarPacientes();
  //     if (this.props.setUpdateDropDown) {
  //       this.props.setUpdateDropDown(false)
  //     }

  //   }
  // }
  // componentDidMount() {

  //   if (!this.props.change) {
  //     alert('DropDownPacientes precisa de uma prop change')
  //   }

  //   this.atualizarPacientes();

  // }
  // componentWillReceiveProps() {
  //   console.log('recebeu props', this.props);
  //   this.atualizarPacientes();
  // }

  async promiseOptions(inputValue) {

    return new Promise((resolve) => {
      clearTimeout(timer);

      timer = setTimeout(async () => {
        if (inputValue !== "") {
          var user = getLoggedInUser();

          // verificar se é cpf
          if (onlyNumbers(inputValue).length === 11) {
            inputValue = inputValue.substr(0, 3) + "." + inputValue.substr(3, 3) + "." + inputValue.substr(6, 3) + "-" + inputValue.substr(9)
          }

          let pacs = await getListPacienteAlgolia(inputValue, user)
          // let pacsAux = pacs.map(p => { return { label: p.nome, value: p.objectID } })

          let items = pacs.map(
            (res, i) => {
              return {
                value: res,
                label: res.paciente.nome + " | " + res.paciente.cpf + " | " + (res.paciente.cns || ''),
              }
            }
          )

          resolve(items)
        }
      }, 1000);
    });

    // setTimeout(async () => {
    //   var user = getLoggedInUser();
    //   let pacs = await getListPacienteAlgolia(inputValue, user)
    //   return pacs.map(p => { return { label: p.nome, value: p.objectID } })
    // }, 500);
  }


  render() {
    return (
      <div className="gb-cont-select" style={{ width: "100%" }}>
        <div className="gb-input-icon">
          {
            this.props.icon && typeof this.props.icon === 'string' && this.props.icon.indexOf('/') < 0 ?
              (<i className={this.props.icon} />) :
              (<img src={this.props.icon} width="20" height="20" />)
          }
        </div>
        <AsyncSelect
          value={this.state.pacienteSelecionado}
          placeholder="Busque por NOME, EMAIL, CPF..."
          isClearable
          loadOptions={this.promiseOptions}
          noOptionsMessage={() => "Nenhum resultado encontrado"}
          onChange={v => {
            this.setState({
              pacienteSelecionado: v
            })
            this.props.change(v)
          }}
          styles={this.props.styles}
        />
      </div>
    );
  }
}